export default __webpack_public_path__ + "static/media/ICTUSICONA.de4980fd.svg";